import Vue from 'vue'
import Vuex from 'vuex'

import DisasterName from './modules/disaster-name'
import Shelter from './modules/shelter'
import ShelterStatus from './modules/shelter-status'
import Damage from './modules/damage'
import Bmkg from './modules/bmkg'

import Auth from './modules/auth'
import Dashboard from './modules/dashboard'

import Officer from './modules/officer'

Vue.use(Vuex)

const DIMS_CURRENT_USER = 'core-currentUser'

function getUserFromStorage () {
  try {
    return JSON.parse(localStorage.getItem(DIMS_CURRENT_USER))
  } catch (e) {
    // do nothing
  }
  return {}
}

const state = {
  visibleSideBar: true,
  visibleNavBar: true,
  currentUser: getUserFromStorage()
}

const mutations = {
  setVisibleSideBar (state, value) {
    state.visibleSideBar = value
  },
  setVisibleNavBar (state, value) {
    state.visibleNavBar = value
  },
  setCurrentUser (state, value) {
    state.currentUser = value
  }
}

const actions = {
  setVisibleSideBar ({ commit }, value) {
    commit('setVisibleSideBar', value)
  },
  showSideBar ({ commit }) {
    commit('setVisibleSideBar', true)
  },
  hideSideBar ({ commit }) {
    commit('setVisibleSideBar', false)
  },
  showNavBar ({ commit }) {
    commit('setVisibleNavBar', true)
  },
  hideNavBar ({ commit }) {
    commit('setVisibleNavBar', false)
  }
}

const getters = {
  visibleSideBar: (state) => state.visibleSideBar,
  visibleNavBar: (state) => state.visibleNavBar,
  isLoggedIn: (state, getters) => !!getters.currentUser.username,
  currentUser: (state) => state.currentUser || {}
}

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    DisasterName,
    Shelter,
    ShelterStatus,
    Damage,
    Bmkg,
    Auth,
    Dashboard,
    Officer
  }
})

export default store
